import { styleLoader } from 'utils/style-loader';

import audioSkinResolver from './skin/audioSkinResolver';
import loadIcons, { getIcon } from './skin/icons-loader';
import settingsMenu from './skin/settings-menu';
import configButton from './skin/config-button';
import sharingBox from './skin/sharing-box';
import { ttsSkinResolver } from './skin/tts-skin';
import { floatingSkinResolver } from './skin/floating-skin';
import containerClass from './skin/container-class';
import levelsIcon from './skin/levels-icon';
import nextUp from './skin/nextUp';

/**
 * @param {object} jwConfig
 * @param {function} loader
 * @return {object}
 */
export function skinLoader(
    jwConfig,
    loader = (path) => styleLoader.load(path),
) {
    // disable multiple loading of JW skin
    if (jwConfig.skin && jwConfig.skin.url) {
        loader(jwConfig.skin.url);

        if (jwConfig.skin.name) {
            jwConfig.skin = {
                name: jwConfig.skin.name,
            };
        } else {
            delete jwConfig.skin;
        }
    }

    return jwConfig;
}

/**
 * Load SVP Skin
 *
 * @param {PlayerModel} svpPlayerModel
 */
export default function svpSkin(svpPlayerModel) {
    ttsSkinResolver(svpPlayerModel);
    audioSkinResolver(svpPlayerModel);
    settingsMenu(svpPlayerModel);
    configButton(svpPlayerModel, {
        icon: getIcon('info'),
    });
    loadIcons(svpPlayerModel);
    sharingBox(svpPlayerModel);
    containerClass(svpPlayerModel);
    levelsIcon(svpPlayerModel);
    nextUp(svpPlayerModel);
    floatingSkinResolver(svpPlayerModel);
}
